import { Query, TrendingSuggestions } from '../types/types'

type Props = {
  trendingSuggestions?: TrendingSuggestions | null
  heading?: string | null
}

export default function SearchBarSuggestions({trendingSuggestions, heading}: Props) {

  if (!trendingSuggestions) {
    return null
  }

  const rootUrlWithoutSlash = window.routes.rootUrlWithoutSlash

  return (
    <div className='flex mx-5 md:mx-0 flex-wrap justify-center md:flex-nowrap'>
      {heading? <div className='text-base-2 text-black mr-5 md-max:mt-1.5'>{heading}</div> : null}
      {trendingSuggestions?.trending.queries.map((suggestion: Query) => {
        if (suggestion === null) {
          return null
        }
        const key = 'search_item_' + suggestion.searchQuery
        const url = `${rootUrlWithoutSlash}/search?q=${suggestion.searchQuery}`
        return <a key={key} href={url} className='text-base-2 text-inactive-state uppercase mr-5 md-max:mt-1.5'>{suggestion.searchQuery}</a>
      })}
    </div>
  )
}